import { Link, RadioField, RadioInput } from '@flos/react-ui';
import CoverableDetailsTemplate from '../../../../../templates/CoverableDetailsTemplate';
import WizardPagetemplate from '../../../../../templates/WizardPagetemplate';
import { useHippoText } from '../../../../../hooks/useHippoText';
import { useState } from 'react';
import ViewInformationModal from '../../../../../shared_components/ViewInformationModal/ViewInformationModal';
import { useUpdateCoverableInformation } from '../../../../../recoil/hooks/useUpdateCoverableInformation';
import { useSaveCoverableInformation } from '../../../../../hooks/useSaveCoverableInformation';
import { useRecoilValue } from 'recoil';
import { getOnsaCurrentProductSelector } from '../../../../../recoil/selectors/getOnsaCurrentProductSelector';
import type { CaravanOnsaDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/uvp';
import type { CoverableInformationToUpdateDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa';
import { track } from '../../../../../utils/trackingUtil';
import { currentOnsaCoverableSelector } from '../../../../../recoil/selectors/currentOnsaCoverableSelector';

const IsStationaryStep = ({ goNext }: { goNext: () => void }): React.JSX.Element => {
    const getHippoText = useHippoText();
    const [showNotSureModal, setShowNotSureModal] = useState(false);
    const currentProduct = useRecoilValue(getOnsaCurrentProductSelector);
    const coverable = useRecoilValue<CaravanOnsaDTO>(currentOnsaCoverableSelector);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [stationary, setStationary] = useState<string>(() => {
        if (coverable?.stationary === undefined) return '';
        return coverable.stationary ? 'yes' : 'no';
    });
    const { saveCoverableInformation } = useSaveCoverableInformation();
    const { updateCoverableInformation } = useUpdateCoverableInformation();

    const goToNextPage = (): void => {
        setIsLoading(true);
        updateCoverableInformation({
            variant: 'caravan',
            stationary: stationary === 'yes'
        });
        const updatedCoverable: CoverableInformationToUpdateDTO = {
            caravan: {
                publicId: coverable.publicId,
                fixedId: coverable.fixedId,
                stationary: stationary === 'yes'
            },
            productToUpdate: currentProduct.flavourName
        };
        void saveCoverableInformation(updatedCoverable).then(() => {
            track(`${currentProduct.flavourName}CoverableInformationIsStationary`, [
                { isStationary: updatedCoverable.caravan?.stationary }
            ]);
            setIsLoading(false);
            goNext();
        });
    };

    return (
        <WizardPagetemplate
            onNext={goToNextPage}
            disableNext={isLoading || !stationary}
            isNextLoading={isLoading}
            hidePrevious
        >
            <CoverableDetailsTemplate
                header={getHippoText('DSS-COVERABLE-INFORMATION-STEP-STATIONARY-HEADER')}
            >
                <RadioField
                    value={stationary}
                    onChange={(event) => {
                        setStationary(event.target.value);
                    }}
                    disabled={isLoading}
                >
                    <RadioInput
                        label={getHippoText('DSS-COVERABLE-INFORMATION-STEP-STATIONARY-NO')}
                        value="no"
                    />
                    <RadioInput
                        label={getHippoText('DSS-COVERABLE-INFORMATION-STEP-STATIONARY-YES')}
                        value="yes"
                    />
                </RadioField>
                <div className="u-text-right">
                    <Link
                        theme={'logo'}
                        onClick={() => {
                            setShowNotSureModal(true);
                        }}
                    >
                        {getHippoText(
                            'DSS-COVERABLE-INFORMATION-STEP-STATIONARY-WHAT-SHOULD-I-ANSWER'
                        )}
                    </Link>
                </div>
            </CoverableDetailsTemplate>

            {showNotSureModal && (
                <ViewInformationModal
                    showModal={showNotSureModal}
                    closeModal={() => {
                        setShowNotSureModal(false);
                    }}
                    modalProps={{
                        title: getHippoText('DSS-INFO-MODAL-UVPLOB-STATIONARY-TITLE'),
                        description: '',
                        rawHtmlDescription: getHippoText('DSS-INFO-MODAL-UVPLOB-STATIONARY-BODY')
                    }}
                />
            )}
        </WizardPagetemplate>
    );
};

export default IsStationaryStep;
